import { Dropdown } from 'components';
import { Api, currencies, languages } from 'lib';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  width: 100%;
  margin: 24px 0 0;

  ${(props) =>
    props.isMobile &&
    `
    flex-direction: column;
  `}
`;

const LanguageAndCurrency = () => {
  let { t, i18n } = useTranslation(),
    { language, isMobile } = useSelector((state) => state.appState),
    currency = useSelector((state) => state.user?.billing?.currency),
    dispatch = useDispatch();

  language = language || 'en';

  function handleLanuageSelect(lang) {
    i18n.changeLanguage(lang.code);

    dispatch({
      type: 'UPDATE_APP_STATE',
      payload: {
        language: lang.code,
        languageManuallySet: true
      }
    });
  }

  function handleCurrencySelect(opt) {
    dispatch({
      type: 'UPDATE_BILLING',
      payload: { currency: opt.value.toLowerCase() }
    });

    Api.post('/billing/changeCurrency', { currency: opt.value });
  }

  return (
    <Container isMobile={isMobile}>
      <Dropdown
        title={t('settings.language')}
        isMobile={isMobile}
        options={languages}
        selected={languages.find((x) => x.code === language)}
        noBorder
        handleSelect={handleLanuageSelect}
      />

      <Dropdown
        title={t('settings.currency')}
        noBorder
        options={currencies}
        selected={currencies.find(
          (x) => x.value.toLowerCase() === (currency?.toLowerCase() || 'usd')
        )}
        handleSelect={handleCurrencySelect}
      />
    </Container>
  );
};

export default LanguageAndCurrency;
